import 'swiper/css'

import { GridCol, GridContainer, useIsWindowBiggerThan } from '@bob/library'
import { CTACard } from '@websrc/App/Components/CTACard/CTACard'
import { mapPageHero } from '@websrc/DataMappers/mapSpot'
import React, { FC, useState } from 'react'
import { Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import { pageHero } from './PageHero.css'

export const PageHero: FC<ReturnType<typeof mapPageHero>> = ({ description, headline, items }) => {
  const [dynamicClassName, setDynamicClassName] = useState(`${pageHero.swiper._} first-slide`)
  const isNotDesktop = !useIsWindowBiggerThan(1025)

  return (
    <GridContainer style={isNotDesktop ? { padding: 0 } : {}}>
      <GridCol noGutter={isNotDesktop}>
        <div className={pageHero._}>
          <div className={pageHero.content}>
            <div className={pageHero.mainText._}>
              <h1 className={pageHero.mainText.headline}>{headline}</h1>
              <p className={pageHero.mainText.description}>{description}</p>
            </div>
            <div className={pageHero.cards}>
              <Swiper
                centeredSlides={isNotDesktop}
                className={dynamicClassName}
                initialSlide={0}
                modules={[Pagination]}
                onSlideChange={(swiper) => {
                  let className = `${pageHero.swiper._}`
                  if (swiper.isBeginning) className += ' first-slide'
                  setDynamicClassName(className)
                }}
                pagination={{ clickable: true }}
                slidesPerView={'auto'}
              >
                {items.map((item, index) => (
                  <SwiperSlide className={pageHero.swiper.slide} key={index}>
                    <CTACard asset={item.asset} cta={item.cta} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </GridCol>
    </GridContainer>
  )
}
